<app-slider></app-slider>

<section class="about-section py-5">
  <div class="container">
    <div class="row align-items-center">
      <!-- Imagen (cambiá el src por una foto real de tu local o estanterías de productos) -->
      <div class="col-lg-6 mb-4 mb-lg-0">
        <a href="{{conf.url}}" target="_blank" rel="noopener noreferrer">
          <img src="{{conf.url}}/assets/img/nosotros.png" alt="Productos de limpieza y bazar en estanterías"
            class="img-fluid rounded shadow" />
        </a>
      </div>

      <!-- Texto adaptado a tu negocio -->
      <div class="col-lg-6">
        <h1 class="display-5 fw-bold mb-3 text-primary">Quiénes somos</h1>
        <p class="lead text-muted">
          En {{conf.name}} creemos que <strong>la limpieza y el orden empiezan con los productos adecuados</strong>.
          Hace varios años comenzamos atendiendo la necesidad de Resistencia y zona:
          <em>¿por qué no tener todo lo necesario para limpiar el hogar, el auto, la piscina o el negocio… y también
            artículos de bazar prácticos al mejor precio?</em>
        </p>
        <p>
          De esa idea nació nuestro negocio, especializado en la venta de
          <strong>productos de limpieza envasados y sueltos (a granel)</strong>, como lavandina, detergentes,
          desengrasantes, cloro, ácidos, jabones base y mucho más.
        </p>
        <p>
          Además ofrecemos una amplia variedad para:
        </p>
        <ul class="list-unstyled lead">
          <li>✔ Limpieza del hogar y cocina</li>
          <li>✔ Limpieza automotriz (ceras, shampoos, desengrasantes)</li>
          <li>✔ Mantenimiento de piscinas (cloro, algicidas, ajustadores de pH)</li>
          <li>✔ Papel higiénico, toallas, bolsas y descartables</li>
          <li>✔ Bazar: mates, bombillas, tuppers, macetas, vajilla económica y más</li>
          <li>✔ Accesorios: escobas, mopas, guantes, pulverizadores</li>
        </ul>
        <p>
          Hoy seguimos creciendo con el mismo compromiso:
          <strong>precios accesibles, variedad, atención personalizada y stock permanente</strong>
          para que encuentres siempre lo que necesitás, ya sea por litro, kilo o paquete.
        </p>
        <p class="mt-4">
          ¡Te esperamos en {{conf.dir}}! Vení a recorrer nuestros pasillos y llevate lo mejor para tu casa, auto
          o
          pileta.
        </p>
      </div>
    </div>
  </div>
</section>

<app-footer [conf]="conf"></app-footer>